import React from "react";

import { Route, Routes } from "react-router-dom";

import ServiceConfiguration from "./configuration/ServiceConfiguration";
import ServiceInfoPanel from "./containers/ServiceInfoPanel";
import ServicesRoutesLayout from "./containers/ServicesRoutesLayout";
import OverviewPage from "./overview/components/ServiceOverview";
import ServiceProcesses from "./processes/ServiceProcessesPage";
import { ServiceProcessGuard } from "./processes/ServiceProcessGuard";
import Profiling from "./profiling/Profiling";

const EnvironmentServicesRoutes = () => (
  <ServicesRoutesLayout>
    <ServiceInfoPanel>
      <Routes>
        <Route
          path="processes"
          element={
            <ServiceProcessGuard>
              <ServiceProcesses />
            </ServiceProcessGuard>
          }
        />
        <Route path="configuration" element={<ServiceConfiguration />} />
        <Route path="profiling" element={<Profiling />} />

        <Route path="" element={<OverviewPage />} />
      </Routes>
    </ServiceInfoPanel>
  </ServicesRoutesLayout>
);
export default EnvironmentServicesRoutes;
